import {useState} from 'react';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {PageControlBar} from 'shells/control-bar/page-control-bar';

import type {MultiPageForm} from '../../types';

import {ContentBlocksTab} from './content-blocks/content-blocks-tab';
import {FormDesignTab} from './form-design/form-design-tab';

type Tab = 'content' | 'design';

interface Props {
    control: Control<MultiPageForm>;
}

export function BlocksAndDesignPanel(props: Props) {
    const [activeTab, setActiveTab] = useState<Tab>('content');

    return (
        <>
            <PageControlBar
                tabs={{
                    options: [
                        {id: 'content', label: 'Content blocks'},
                        {id: 'design', label: 'Form design'},
                    ],
                    selectedTab: activeTab,
                    onChangeTab: (tab) => setActiveTab(tab as Tab),
                }}
            />
            <div className='flex-1 overflow-auto pad-16'>
                {activeTab === 'content' ? (
                    <ContentBlocksTab control={props.control} />
                ) : (
                    <FormDesignTab />
                )}
            </div>
        </>
    );
}
